<template>
  <div class="user-recommendation-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-button type="primary" size="small" @click="recommendAction('add')">+ 新增</el-button>
    </div>
    <!--表格数据-->
    <el-table :data="tableData" style="width: 100%" border v-loading="loading" element-loading-text="拼命加载中"  element-loading-spinner="el-icon-loading">

      <el-table-column prop="uid" label="推荐用户ID" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.uid || '未知'}}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="id" label="id" align="center" min-width="120">
        <template slot-scope="scope">
          <span>{{scope.row.id || '未知'}}</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="sortKey" label="排序" align="center" min-width="120">
      </el-table-column>
     <el-table-column prop="active" label="激活状态" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.active" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center">
        <template slot-scope="scope">
          {{scope.row.updatedAt | changeDate}}
        </template>
      </el-table-column>
      <el-table-column prop="createdAt" label="创建时间" align="center">
        <template slot-scope="scope">
          {{scope.row.createdAt | changeDate}}
        </template>
      </el-table-column>
       <el-table-column label="操作" align="center" fixed="right" width="130">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="recommendAction('edit',scope.row)"></el-button>
          <el-button type="danger" size="mini" icon="el-icon-delete" @click="removeRecommend(scope.row.id)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[ 5, 10, 15, 20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
    <!--新增，编辑用户推荐弹窗组件-->
    <recommend-action ref="recommendAction" @handlerrecommend="recommend"></recommend-action>
  </div>
</template>
<script>
import RecommendAction from './components/recommendAction'
import API from '@/api'
export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      // 列表数据
      tableData: [],
      total: 0,
      form: {
        id: '',
        uid: '',
        sortKey: '',
      },
      params: {
        pageNumber: 1,
        pageSize: 10,
      },
     
    }
  },
  components: {
    RecommendAction
  },
  created() {
    this.getRecommendationList()

  },
  methods: {
    // 请求用户推荐列表列表
    getRecommendationList() {
      this.loading = true
      API.getRecommendationList(this.params).then(res => {
        if (res.code === 200 && res.data.infos) {
          this.tableData = res.data.infos
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    removeRecommend(id) {
      this.$confirm('您确定要删除当前推送吗？', '删除提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        API.delRecommendation({ id: id }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getRecommendationList()
          } else {
            this.$message.error('删除失败！');
          }
        })
      }).catch(() => {
        
      })
    },
    recommend() {
      this.getRecommendationList()
      this.params.pageNumber = 1
    },
    recommendAction(type,data) {
      this.$refs.recommendAction.open(type,data)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRecommendationList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRecommendationList()
    },
  }
}
</script>

